import React, { FC, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { PagesRoutes } from '../../store/routes';
import {
  ReflinkCard,
  ReflinkActions,
  ReflinkCloseButton,
  ReflinkCtaButtonCompact,
  ReflinkFrame,
  ReflinkHeroFrame,
  ReflinkHeroImg,
  ReflinkJoinLink,
  preloadReflinkImage,
  REFLINK_STEP_1_SRC,
  REFLINK_STEP_2_SRC,
} from './reflinkShared';

export const ReflinkStep1Page: FC = () => {
  const navigate = useNavigate();
  const [step2Prefetching, setStep2Prefetching] = useState(false);

  useEffect(() => {
    void preloadReflinkImage(REFLINK_STEP_2_SRC);
  }, []);

  const goToStep2 = async () => {
    if (step2Prefetching) return;
    setStep2Prefetching(true);
    try {
      await preloadReflinkImage(REFLINK_STEP_2_SRC);
    } catch {
      // still continue — step 2 has its own reveal when the hero loads
    }
    navigate(PagesRoutes.ReferralLinkStep2);
  };

  return (
    <>
      <Helmet>
        <title>Referral link</title>
      </Helmet>
      <ReflinkCard>
        <ReflinkFrame>
          <ReflinkCloseButton type="button" aria-label="Close" onClick={() => navigate(PagesRoutes.Main, { replace: true })}>
            ×
          </ReflinkCloseButton>
          <ReflinkHeroFrame>
            <ReflinkHeroImg src={REFLINK_STEP_1_SRC} alt="Create instant referral link" />
          </ReflinkHeroFrame>
          <ReflinkActions
            style={{ bottom: '6.4%' }}
            $desktopTranslateY={'calc(-100% + clamp(10px, 6cqi, 20px) + 8px + clamp(32px, 9.5cqi, 44px))'}
          >
            <ReflinkCtaButtonCompact type="button" disabled={step2Prefetching} onClick={() => void goToStep2()}>
              Create instant link now
            </ReflinkCtaButtonCompact>
            <ReflinkJoinLink type="button" onClick={() => navigate(PagesRoutes.Main)}>
              Join
            </ReflinkJoinLink>
          </ReflinkActions>
        </ReflinkFrame>
      </ReflinkCard>
    </>
  );
};

export default ReflinkStep1Page;

